import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tabPleine", "tabCredit", "tabNue"]

  connect() {
    console.log("Simulator tabs controller connected")
  }

  selectMode(event) {
    event.preventDefault()
    const mode = event.currentTarget.dataset.mode
    console.log("Switching to mode:", mode)

    // Update tab styles
    this.tabPleineTarget.classList.toggle("text-dark-blue", mode === "pleine")
    this.tabPleineTarget.classList.toggle("text-gray-500", mode !== "pleine")
    this.tabPleineTarget.classList.toggle("border-primary-green", mode === "pleine")
    this.tabPleineTarget.classList.toggle("border-transparent", mode !== "pleine")

    this.tabCreditTarget.classList.toggle("text-dark-blue", mode === "credit")
    this.tabCreditTarget.classList.toggle("text-gray-500", mode !== "credit")
    this.tabCreditTarget.classList.toggle("border-primary-green", mode === "credit")
    this.tabCreditTarget.classList.toggle("border-transparent", mode !== "credit")

    this.tabNueTarget.classList.toggle("text-dark-blue", mode === "nue")
    this.tabNueTarget.classList.toggle("text-gray-500", mode !== "nue")
    this.tabNueTarget.classList.toggle("border-primary-green", mode === "nue")
    this.tabNueTarget.classList.toggle("border-transparent", mode !== "nue")

    // Trigger simulator controller to update
    const simulatorController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller="simulator"]'),
      "simulator"
    )

    if (simulatorController) {
      simulatorController.modeValue = mode

      // Show/hide relevant sections
      const creditSection = document.querySelector('[data-simulator-target="creditSection"]')
      const nueSection = document.querySelector('[data-simulator-target="nueSection"]')
      const creditInfo = document.querySelector('[data-simulator-target="creditInfo"]')

      if (creditSection) creditSection.classList.toggle("hidden", mode !== "credit")
      if (nueSection) nueSection.classList.toggle("hidden", mode !== "nue")
      if (creditInfo) creditInfo.classList.toggle("hidden", mode !== "credit")

      // Handle disabled fields based on mode
      const rateSlider = document.querySelector('[data-simulator-target="rateSlider"]')
      const rateContainer = rateSlider?.closest('.field-container')
      const scpiSelector = document.querySelector('[data-simulator-target="scpiSelector"]')

      if (mode === "nue") {
        // In nue-propriété, no income during démembrement - always disabled
        if (rateSlider) {
          rateSlider.disabled = true
          rateContainer?.classList.add('opacity-50', 'pointer-events-none')
        }
      } else {
        // For pleine and credit modes - enable unless SCPI is selected
        if (rateSlider) {
          const scpiSelected = scpiSelector && scpiSelector.value !== ""
          rateSlider.disabled = scpiSelected

          if (scpiSelected) {
            rateContainer?.classList.add('opacity-50', 'pointer-events-none')
          } else {
            rateContainer?.classList.remove('opacity-50', 'pointer-events-none')
          }
        }
      }

      simulatorController.calculate()
    }
  }
}